import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    gap: 10px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
  }
`;

export const Title = styled(Typography.Title)`
  padding: 5px 0;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 16px;
`;

export const Subtitle = styled(Box)`
  gap: 20px;
  margin: 0 0 10px 0;
  font-size: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 5px 0;
  }
`;

export const SubtitleBonus = styled.div`
  background-color: ${({ theme }) => theme.palette.secondary.background};
  padding: 10px 15px;
  border-radius: 14px;
  position: relative;
`;

export const SubtitleBonusRow = styled.div`
  display: grid;
  grid-template-columns: 55px 1fr;
  align-items: center;

  &:not(:last-of-type) {
    margin-bottom: 3px;
  }
`;

export const SubtitleBonusText = styled(Typography.Body).attrs(() => ({
  $variant: '3',
}))`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const SubtitleBonusMessageOld = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-decoration: line-through;
  display: flex;
  align-items: center;
  gap: 1px;
  text-transform: uppercase;
  padding: 5px 7px;
  font-size: 12px;
  font-weight: 500;
`;

export const SubtitleBonusMessage = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))`
  padding: 5px 9px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
  border-radius: 30px;
  max-width: fit-content;
  display: flex;
  align-items: center;
  gap: 5px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
`;

export const SubtitleBonusLabel = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))<{ $bgColor: string }>`
  text-transform: uppercase;
  position: absolute;
  top: 0;
  right: 0;
  color: ${({ theme }) => theme.palette.primary.background};
  padding: 5px 7px;
  border-radius: 0 14px;
  font-size: 12px;
  font-weight: 500;

  background-color: ${({ $bgColor }) => $bgColor};
`;

export const ServiceCheckboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ServiceLabelText = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NewPrice = styled(Typography.Header).attrs(() => ({
  $variant: '4',
  as: 'span',
}))`
  color: ${({ theme }) => theme.palette.brand.main};
`;
